/**
 * フォームフィールド名とGoogle Form Entry IDのマッピング
 */
export const FIELD_TO_ENTRY_ID_MAP = {
  // プロフィール
  age: 'entry.2106124052',
  gender: 'entry.1407262755',
  area: 'entry.846005035',
  xAccount: 'entry.1386795470',

  // 職歴・収入
  workExperience: 'entry.1067083786',
  allowance: 'entry.1303439900',
  moneyManagement: 'entry.1297179791',

  // 質問項目
  q1: 'entry.1370061467',
  q1Other: 'entry.1370061467_other',
  q2: 'entry.1431583396',
  q2Other: 'entry.1431583396_other',
  q3: 'entry.1258548229',
  q4: 'entry.1053376328',
  q5: 'entry.1643573443',
  q5Other: 'entry.1643573443_other',
  q6: 'entry.2012701841',
  q7: 'entry.2012701841',
  q7Other: 'entry.2012701841_other',
  q8: 'entry.995902711',
};

/**
 * フィールド名からセレクタを取得
 * @param {string} fieldName - フィールド名
 * @returns {string|null} - CSSセレクタ
 */
export function getFieldSelector(fieldName) {
  const entryId = FIELD_TO_ENTRY_ID_MAP[fieldName];
  if (!entryId) {
    return null;
  }

  // "other"フィールドは親要素を対象にする
  if (entryId.endsWith('_other')) {
    const baseEntryId = entryId.replace('_other', '');
    return `input[name="${baseEntryId}"]`;
  }

  return `input[name="${entryId}"]`;
}
